import React from 'react';
import ProfileImage from '../../profileImage';

const TeamPlayers = ({ teamMembers, startChat }) => {
  const players = teamMembers.filter(m => m.accountType === 'player');

  return (
    <div>
      <h3 className="text-xl font-semibold mb-6">Team Players ({players.length})</h3>
      {players.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"/>
            </svg>
          </div>
          <h4 className="text-lg font-medium text-gray-900 mb-2">No Players Found</h4>
          <p className="text-gray-500">Players will appear here when they join the team</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {players.map((player) => (
            <div key={player._id} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center space-x-4 mb-4">
                <div className="relative">
                  <ProfileImage
                    image={player.profilePicture}
                    alt={player.userName}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  {player.jerseyNumber && (
                    <div className="absolute -top-1 -left-1 w-6 h-6 text-white text-xs font-bold rounded-full flex items-center justify-center" style={{backgroundColor: '#e25820'}}>
                      {player.jerseyNumber}
                    </div>
                  )}
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900">@{player.userName}</h4>
                  <p className="text-sm text-gray-500">{player.position || 'Player'}</p>
                  <p className="text-xs text-gray-400 mt-1">
                    Joined {new Date(player.joinDate).toLocaleDateString()}
                  </p>
                </div>
              </div>
              
              <div className="mt-4 p-3 bg-orange-50 rounded-lg">
                <p className="text-sm text-gray-600">
                  <span className="font-medium">Role:</span> {player.role?.name || 'Player'}
                </p>
                {player.title && (
                  <p className="text-sm text-gray-600 mt-1">
                    <span className="font-medium">Title:</span> {player.title}
                  </p>
                )}
              </div>
              
              <button
                onClick={() => startChat(player)}
                className="w-full mt-4 px-4 py-2 text-white rounded-lg hover:shadow-md transition-all duration-300 text-sm flex items-center justify-center space-x-2"
                style={{backgroundColor: '#e25820'}}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#d14d1a'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#e25820'}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
                </svg>
                <span>Chat with {player.userName}</span>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeamPlayers; 